export default {
  nav: { home: "Início", treatments: "Tratamentos", about: "Sobre mim", studio: "Estúdio", contact: "Contacto" },
  cta: {
    book: "Marcar consulta",
    discover: "Descobrir tratamentos",
    moreAbout: "Mais sobre mim",
    allTreatments: "Todos os tratamentos",
    send: "Enviar pedido",
    sending: "A enviar…",
    call: "Ligar agora",
    whatsapp: "Escrever por WhatsApp",
    backHome: "Voltar ao início",
    discoverStudio: "Descobrir o estúdio",
    request: "Pedir marcação",
    readMore: "Saber mais",
  },
  header: { openMenu: "Abrir menu", closeMenu: "Fechar menu", languageLabel: "Escolher idioma" },
  home: {
    heroEyebrow: "Beauty & Wellness · Basileia",
    heroLines: ["Beleza.", "Relaxamento.", "Bem-estar."],
    heroWelcomePre: "Bem-vinda à",
    heroWelcomeBrand: "IMPERIUM.",
    heroSub: "Cosmética profissional e massagens relaxantes para mais luminosidade, calma e bem-estar.",
    heroQuote: "«Acompanhamento pessoal, tratamentos de alta qualidade e um ambiente em que pode chegar plenamente a si mesma.»",
    trustNo: "01",
    trustEyebrow: "Confiança",
    trustTitle: "A beleza começa com confiança.",
    trustText: "A sua pele, o seu corpo e o seu bem-estar merecem atenção. Na IMPERIUM encontram-se tratamento profissional, aconselhamento pessoal e um ambiente em que se pode sentir completamente à vontade.",
    trustPoints: ["Acompanhamento pessoal", "Tratamento individual", "Ambiente de elevada qualidade", "Cosmética profissional", "Tempo para as suas necessidades"],
    servicesNo: "02",
    servicesEyebrow: "Tratamentos",
    servicesTitle: "O que gostaria de colocar hoje no centro?",
    servicesIntro: "Massagem, cosmética e styling – cada tratamento adaptado individualmente a si.",
    auszeitNo: "03",
    auszeitEyebrow: "A sua pausa",
    auszeitTitle: "A sua pausa começa no momento em que se escolhe a si mesma.",
    auszeitText: "Deixe o quotidiano para trás por um momento. Sinta calma, cuidado e energia renovada – adaptados a si.",
    ablaufEyebrow: "Como funciona",
    ablaufTitle: "É assim tão simples começar o seu momento Imperium",
    steps: [
      { t: "Escolher o tratamento", d: "Descobre o que lhe faz bem hoje." },
      { t: "Entrar em contacto", d: "Muito simples: por formulário, WhatsApp ou chamada." },
      { t: "Ser aconselhada pessoalmente", d: "Tudo é adaptado a si e aos seus desejos." },
      { t: "Chegar relaxada", d: "Entra e o quotidiano fica lá fora." },
      { t: "Desfrutar do tratamento", d: "O seu momento Imperium – só para si." },
    ],
    expertNo: "04",
    expertEyebrow: "A sua especialista",
    expertName: "Leidiane Alcântara",
    expertText: "Profissional de estética e bem-estar – com dedicação, formação contínua e um olhar atento às necessidades individuais de cada pessoa.",
    studioNo: "05",
    studioEyebrow: "O estúdio",
    studioTitle: "Um espaço que nasce com amor ao detalhe.",
    studioText: "Na Basileia está a nascer a IMPERIUM Beauty & Wellness – um estúdio moderno, elegante e confortável, criado para uma experiência completa de beleza, cuidado e bem-estar.",
    galleryEyebrow: "Galeria",
    galleryTitle: "Vislumbres do universo IMPERIUM",
    finalTitle: "Pronta para a sua pausa mais bonita?",
    finalText: "Reserve tempo para si. Será um prazer conhecê-la pessoalmente.",
    marquee: ["Estética", "Massagem", "Drenagem linfática", "Cuidados de rosto", "Maquilhagem", "Bem-estar"],
  },
  treatmentsPage: {
    eyebrow: "Tratamentos",
    title: "Os seus tratamentos na IMPERIUM",
    intro: "Massagem, cosmética e styling – descubra o que lhe faz bem hoje. Cada tratamento é adaptado individualmente a si.",
    massage: "Massagem & Corpo",
    beauty: "Cosmética & Styling",
  },
  treatment: {
    back: "Todos os tratamentos",
    related: "Outros tratamentos",
    ctaTitle: "Pedir este tratamento",
    ctaText: "Fale-me dos seus desejos – aconselho-a pessoalmente e juntas encontramos o seu momento Imperium.",
  },
  about: {
    eyebrow: "Sobre mim",
    title: "Leidiane Alcântara",
    role: "Estética & Bem-estar",
    bio: [
      "Sou Leidiane Alcântara, profissional da área de estética e bem-estar, apaixonada por cuidar de pessoas e realçar o que existe de mais belo em cada uma delas.",
      "Com dedicação, aperfeiçoamento contínuo e um olhar atento às necessidades individuais, construí o meu percurso com muito trabalho, responsabilidade e amor pelo que faço.",
      "Acredito que cada pessoa é única, e por isso ofereço um atendimento personalizado, com técnicas modernas e seguras, sempre priorizando o cuidado, a estética e o bem-estar.",
    ],
    storyEyebrow: "A história",
    storyTitle: "O sonho da IMPERIUM",
    story: [
      "Agora, estou a realizar um grande sonho: estou a abrir a IMPERIUM Beauty & Wellness – um lindo estúdio criado especialmente para proporcionar uma experiência completa de beleza, cuidado e bem-estar.",
      "Cada detalhe está a ser preparado com muito carinho para que cada cliente se sinta acolhida, valorizada e viva um momento único, num ambiente moderno, elegante e confortável.",
      "Será um espaço onde a estética, o relaxamento e a autoestima se encontram – porque cuidar de si é a minha maior missão.",
    ],
    quote: "«Cuidar de si é a minha maior missão.»",
    philosophyEyebrow: "Filosofia",
    philosophyTitle: "Cada pessoa é única.",
    philosophyText: "Atendimento personalizado, técnicas modernas e seguras – sempre com o foco no cuidado, na estética e no bem-estar.",
    ctaTitle: "Vamos conhecer-nos.",
    ctaText: "Aguardo a sua mensagem com alegria – pessoal, simples e sem compromisso.",
  },
  studio: {
    eyebrow: "Estúdio",
    title: "IMPERIUM na Basileia",
    intro: "Um estúdio criado para a beleza, o cuidado e o bem-estar – moderno, elegante e confortável.",
    preparing: "O estúdio está atualmente a ser preparado com muito amor ao detalhe. Cada recanto nasce com o objetivo de que se sinta bem-vinda e valorizada desde o primeiro momento.",
    locationLabel: "Localização",
    location: "Austrasse 31, 4051 Basel, Switzerland",
    ctaTitle: "Faça parte desde o início.",
    ctaText: "Escreva-me – será um prazer ouvi-la.",
  },
  contact: {
    eyebrow: "Contacto",
    title: "O seu momento Imperium começa aqui.",
    intro: "Dúvida, desejo ou marcação – escreva-me. Respondo pessoalmente.",
    locationLabel: "Localização",
    phoneLabel: "Telefone & WhatsApp",
    emailLabel: "E-mail",
    instagramLabel: "Instagram",
    formTitle: "Enviar pedido",
  },
  form: {
    name: "Nome e apelido",
    email: "E-mail",
    phone: "Telemóvel (opcional)",
    treatment: "Tratamento",
    treatmentPlaceholder: "Selecionar tratamento",
    noPreference: "Ainda não sei / Aconselhamento",
    message: "Mensagem",
    messagePlaceholder: "Em que posso ajudá-la?",
    privacy: "Li a política de privacidade e aceito o tratamento dos meus dados para responder ao meu pedido.",
    submit: "Enviar pedido",
    sending: "A enviar…",
    success: "Muito obrigada! O seu pedido chegou. Responderei pessoalmente o mais breve possível.",
    error: "Infelizmente ocorreu um erro. Tente novamente ou escreva-me por WhatsApp.",
    required: "Preencha todos os campos obrigatórios.",
    invalidEmail: "Introduza um endereço de e-mail válido.",
    privacyRequired: "Confirme a política de privacidade.",
  },
  footer: {
    tagline: "Estética · Massagem · Bem-estar",
    navTitle: "Navegação",
    treatmentsTitle: "Tratamentos",
    contactTitle: "Contacto",
    legalTitle: "Informação legal",
    impressum: "Impressum",
    privacy: "Privacidade",
    rights: "Todos os direitos reservados.",
    location: "Austrasse 31, 4051 Basel, Switzerland",
  },
  impressum: {
    title: "Impressum",
    operatorLabel: "Titular",
    operator: "IMPERIUM Beauty & Wellness — Leidiane Alcântara",
    contactLabel: "Contacto",
    contentLabel: "Responsável pelo conteúdo",
    note: "As restantes informações legais estão a ser completadas e serão adicionadas em breve.",
  },
  privacyPage: {
    title: "Política de privacidade",
    responsibleTitle: "Responsável",
    responsibleText: "IMPERIUM Beauty & Wellness — Leidiane Alcântara, Austrasse 31, 4051 Basel, Switzerland.",
    dataTitle: "Dados do formulário de contacto",
    dataText: "Quando me escreve através do formulário, os seus dados (nome, e-mail, telefone, mensagem) são utilizados exclusivamente para responder ao seu pedido e não são partilhados com terceiros.",
    storageTitle: "Armazenamento no navegador",
    storageText: "Este website guarda apenas a sua escolha de idioma e a sua decisão sobre cookies localmente no seu navegador. Não são utilizados cookies de rastreamento.",
    rightsTitle: "Os seus direitos",
    rightsText: "Tem sempre o direito de aceder, corrigir ou eliminar os seus dados. Basta escrever para kontakt@imperium-wellness.ch.",
  },
  google: { label: "IMPERIUM no Google", rate: "Avaliar no Google", reviews: "Ver avaliações" },
  notfound: {
    title: "404",
    heading: "Esta página não foi encontrada.",
    text: "Talvez encontre aqui o que procura:",
  },
  cookie: {
    text: "Este website utiliza apenas armazenamento tecnicamente necessário – por exemplo, para a sua escolha de idioma. Não são definidos cookies de rastreamento.",
    accept: "Entendido",
    more: "Privacidade",
  },
  seo: {
    homeTitle: "IMPERIUM Beauty & Wellness | Cosmética, Estética e Massagens na Basileia",
    homeDesc: "Cosmética profissional e massagens relaxantes para mais luminosidade, calma e bem-estar. A sua beleza. O seu momento. O seu Imperium.",
  },
};
